import english from 'i18n-iso-countries/langs/en.json';
import { getName, registerLocale } from 'i18n-iso-countries';

import { useCurrentLocale } from 'utils/hooks/useTranslation';
import { useEffect } from 'react';

export const useGetCountryDisplayName = () => {
  const { language } = useCurrentLocale();

  useEffect(() => registerLocale(english), []);

  return (countryCode: string) => {
    return getName(countryCode, language, { select: 'official' }) ?? countryCode;
  };
};
